// extracted by mini-css-extract-plugin
module.exports = {"Container":"page-loading_Container__W4bX0"};